module.exports = __webpack_public_path__ + "static/media/ic_file_download_hover_24px.70ee34b8.svg";